// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y96p","footer":"styles_footer__3dwre","passCodeTooltip":"styles_passCodeTooltip__2r6-x"};